/**
 * Block: three-column-cards
 * Swiper slider + modal functionality
 */

export function init() {
  const container = document.querySelector('.three-column-cards.slider');
  if (!container || typeof Swiper === 'undefined') return;

  // Initialize Swiper
  new Swiper('.three-column-cards__swiper', {
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    autoplay: {
      delay: 10000,
    },
    pagination: {
      el: '.three-column-cards__dots',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 36,
      },
    },
  });

  // Modal functionality
  container.querySelectorAll('.three-column-cards__trigger-modal').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.target;
      const modal = document.getElementById(target);
      if (!modal) return;
      modal.style.display = 'flex';
    });
  });

  document.querySelectorAll('.three-column-cards__modal-close').forEach((btn) => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.target;
      const modal = document.getElementById(target);
      if (!modal) return;
      modal.style.display = 'none';
    });
  });

  // Close modal on backdrop click
  document.querySelectorAll('.three-column-cards__modal-wrapper').forEach((wrapper) => {
    wrapper.addEventListener('click', (e) => {
      if (e.target === wrapper) {
        wrapper.style.display = 'none';
      }
    });
  });
}
